
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/shopping-list",
      function () {
        return require("private-next-pages/[locale]/shopping-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/shopping-list"])
      });
    }
  